export class PerformanceAdvice {

  public type: string;
  public title: string;
  public score: number;
  public grade: string;
  public advice: string;

}
